import { useTheme } from '@mui/material';
import { useMemo } from 'react';
import { useDropzone } from 'react-dropzone';
import { Trans } from 'react-i18next';
import { useAudioFileContext } from '../../context';
import { DROPZONE_CONFIG } from './constants';
import {
  StyledAudioFileIcon,
  StyledContainer,
  StyledHintText,
  StyledLink,
} from './styled';
import useUploadAudioValidation from './useUploadAudioValidation';

const Dropzone = () => {
  const theme = useTheme();

  const { setAudioFile, validationError } = useAudioFileContext();

  const { onDropAccepted, onDropRejected } = useUploadAudioValidation({
    onSuccess: (audioFile) => setAudioFile(audioFile),
  });

  const { open, isDragAccept, isDragReject, getRootProps, getInputProps } =
    useDropzone({
      ...DROPZONE_CONFIG,
      onDropAccepted,
      onDropRejected,
    });

  const isFocused = isDragAccept || isDragReject;

  const borderStyle = useMemo(() => {
    if (isFocused) {
      return { border: `2px solid ${theme.palette.grey[100]}` };
    }
    if (validationError) {
      return { border: `1px solid ${theme.palette.error.main}` };
    }

    return { borderColor: theme.palette.grey[600] };
  }, [theme, isFocused, validationError]);

  return (
    <StyledContainer {...getRootProps()} sx={{ ...borderStyle }}>
      <input {...getInputProps()} accept="audio/wav" />
      <StyledAudioFileIcon />
      <StyledHintText align="center">
        <Trans i18nKey="distribution:uploadAudioModal:hint">
          <StyledLink onClick={open} />
        </Trans>
      </StyledHintText>
    </StyledContainer>
  );
};

export default Dropzone;
